import { isAxiosError } from "axios";
import { BarragemData } from "../../../context";
import { RequestError, useApi } from "../../../services";
import { SelectedItem } from "../../barragem";
import { HidroLayer, HidroLayerGroup, PaintPoint, PaintTypes } from "../../mapa";
import { Circle, geoJSON, Marker } from "leaflet";
import { useParams } from "react-router-dom";

interface GeoJsonItem {
  name: string;
  feature: GeoJSON.FeatureCollection;
  style: PaintTypes;
  layer?: string;
}
export const getShapes = async (
  barragem: number,
  layers: SelectedItem[],
  styles: PaintTypes[],
): Promise<HidroLayerGroup | RequestError> => {
  const api = useApi();

  if (!barragem) {
    return {
      error: "Layers Error",
      message: `Erro ao obter dados das Layers`,
    };
  }

  const group = new HidroLayerGroup({
    name: "dados",
    showing: true,
    layers: [],
  });

  let layer = "";
  const geojsons: GeoJsonItem[] = [];

  for (const i in layers) {
    const layerData = layers[parseInt(i)];
    if (!layerData.selected) continue;

    layer = layerData.name;
    const data = await api.damFiles.shapeData(barragem, layer, layerData.layer);
    if ("error" in data) {
      return {
        error: "Layers Error",
        message: `Erro ao obter dados da Layer ${layer}`,
      };
    }

    geojsons.push({
      name: layer,
      feature: data,
      layer: layerData.layer,
      style: styles[parseInt(i)]
    });
  }

  const geometries = geojsons.map((geom) => {
    const style = geom.style;

    const hidroLayers: HidroLayer[] = [];
    geoJSON(geom.feature, {
      style: () => style,
      onEachFeature: (feature, layer) => {
        const isMarker = (layer instanceof Marker);
        if (!("icon" in style) && !("iconStr" in style) && isMarker) {
          const latLon = (layer as Marker).getLatLng();
          const radius = (style as PaintPoint).radius ?? 5;
          layer = new Circle(latLon, radius, (style as PaintPoint));
        }

        hidroLayers.push(new HidroLayer({
          name: geom.layer ?? `layer ${feature.id ?? 0}`,
          layer: layer,
          showing: true,
          style: style,
        }));
      }
    });

    if (hidroLayers.length > 1) {
      return new HidroLayerGroup({
        name: geom.layer ?? (geom.name.split(".")[0]),
        showing: true,
        layers: hidroLayers,
        clusterize: style.clusterize,
        clusterizeOptions: style.clusterizeOptions,
      });
    }

    const layerReturn = hidroLayers[0];
    layerReturn.name = geom.layer ?? (geom.name.split(".")[0]);
    return layerReturn;
  });

  group.flat(geometries);
  return group;
};